<template>
  <img v-bind="$attrs" :src="realsrc" />
</template>


<script>
import PriorityQueue from '../lib/priorityqueue'
import asleep from 'await-sleep'

// Limit image loading concurrency
const imageLoadingQueue = new PriorityQueue({
  concurrency: 5
})

// 1 -3 device pixel ratio, that's what we support.
const roundedFactor = Math.ceil(window.devicePixelRatio)
const maxFactor = 2
const factor = roundedFactor < 1 ? 1 : (roundedFactor > maxFactor ? maxFactor : roundedFactor)


const scalerBaseUrl = window.envConfig.SCALER_BASEURL ? window.envConfig.SCALER_BASEURL : window.location.protocol + '//img.' + window.location.host

export default {
  inheritAttrs: false,
  props: ['src', 'preset'],
  name: 'smart-img',
  data: () => ({
    isloaded: null,
    visible: false,
    realsrc: "",
  }),
  mounted() {
    this.isloaded = false

    // @todo set this.visible true, when element is actually visible.
    this.visible = true
  },
  methods: {
    getPresetUrl() {
      return this.generateUrl(this.src, this.preset, factor)
    },
    generateUrl(src, preset = null, factor = null) {
      if (src.indexOf('http://') !== 0 && src.indexOf('https://') !== 0) {
        src = window.location.protocol + '//' + window.location.host + src
      }
      if (!preset) return src
      if (factor) preset = preset + '-x' + factor
      return scalerBaseUrl + '/' + preset + '/?url=' + encodeURI(src)
    },

    loadSrc: function (src, attempt = 0) {
      const self = this
      self.isloaded = false
      imageLoadingQueue.push(async function () {
        //console.log("Loading " + src + " - #" + attempt)
        return new Promise(function (resolve, reject) {
          self.$el.addEventListener('load', function (e) {
            self.isloaded = true
            resolve()
          })
          self.$el.addEventListener('error', function (e) {
            self.realsrc = ""
            reject()
          })
          self.realsrc = src
        })
      }).catch(error => {
        if (attempt < 3) {
          const backoffms = (2**attempt) * 1000
          asleep(backoffms).then(() => self.loadSrc(src, attempt + 1))
        } else {
          self.isloaded = true
          //console.log("could not load " + src)
          self.realsrc = require('@/assets/img/notfound.png')
        }
      })
    },
  },
  watch: {
    visible: function (new_value, old_value) {
      if (new_value && !old_value) {
        this.loadSrc(this.getPresetUrl())
      }
    },
    preset: async function (new_value, old_value) {
      if (this.visible) this.loadSrc(this.getPresetUrl())
    },
    src: async function (new_value, old_value) {
      if (this.visible) this.loadSrc(this.getPresetUrl())
    }
  }
}
</script>
